import UsersYouMayKnow from './UsersYouMayKnow';

export default UsersYouMayKnow;
